import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DocumentTextIcon,
  SearchCircleIcon,
  ClipboardListIcon,
} from '@heroicons/react/solid';
import NavCard from '../common/NavCard';
import { ROUTES } from '../../constants/routes';
import '../../styles/main.scss';
import '../../styles/dashboard.scss';

const MODULES = [
  {
    id: 'tech-doc',
    title: 'Tech Doc',
    description:
      'Upload project files and generate technical documentation, architecture summaries, and related deliverables with AI assistance.',
    path: ROUTES.DOC_GENERATION,
    icon: DocumentTextIcon,
  },
  {
    id: 'rag-system',
    title: 'RAG System',
    description:
      'Search and query your enterprise knowledge base using retrieval-augmented generation for accurate, context-aware answers.',
    path: ROUTES.RAG_SYSTEM,
    icon: SearchCircleIcon,
  },
  {
    id: 'brd',
    title: 'BRD for Oracle Forms',
    description:
      'Generate Business Requirement Documents for Oracle Forms modernization projects.',
    path: ROUTES.BRD,
    icon: ClipboardListIcon,
  },
];

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="dashboard-page" role="main" aria-labelledby="dashboard-heading">
      <div className="dashboard-page__inner">
        <header className="dashboard-header">
          <h1 id="dashboard-heading" className="dashboard-title">
            Welcome to iBEAM Platform
          </h1>
          <p className="dashboard-subtitle">Select a module to continue</p>
        </header>

        <div className="dashboard-grid">
          {MODULES.map((module) => (
            <NavCard
              key={module.id}
              title={module.title}
              description={module.description}
              icon={module.icon}
              onClick={() => navigate(module.path)}
              aria-label={`${module.title}: ${module.description}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
